<div class="registration-container">
  @switch (currentStep()) {
    @case (0) {
      <acl-account-confirm (slideTo)="updateStep($event)" />
    }

    @case (1) {
      <acl-account-details [slideNo]="2" (slideTo)="updateStep($event)" />
    }

    @case (2) {
      <acl-register-company-details
        [slideNo]="5"
        [installer]="installer()"
        (slideTo)="updateStep($event)"
      />
    }

    @case (3) {
      <acl-register-contact-details
        [slideNo]="4"
        [installer]="installer()"
        (slideTo)="updateStep($event)"
      />
    }

    @case (4) {
      <acl-register-professional-details
        [slideNo]="5"
        [installer]="installer()"
        (slideTo)="updateStep($event)"
      />
    }

    @case (5) {
      <acl-register-successful (slideTo)="updateStep($event)" />
    }
  }
</div>
